import { render, staticRenderFns } from "./BrandingPanel.vue?vue&type=template&id=a1c2edd4"
import script from "./BrandingPanel.vue?vue&type=script&lang=js"
export * from "./BrandingPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports